import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Hidden } from "@material-ui/core";
import DesktopHome from "./DesktopHomePage";
import MobileHome from "./MobileHome";
import { AddChatDialogProvider } from "../contexts/AddChatDialogContext";
const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
}));

export default function Home() {
  // const classes = useStyles();

  return (
    <div >
      <Hidden smDown>
        <AddChatDialogProvider>
          <DesktopHome />
        </AddChatDialogProvider>
      </Hidden>
      <Hidden smUp>
        <AddChatDialogProvider>
          <MobileHome />
        </AddChatDialogProvider>
      </Hidden>
    </div>
  );
}
